exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-finder-container{max-width:100%;display:inline-flex;align-items:baseline;vertical-align:baseline}.user-finder-container .search-button,.user-finder-container .user-finder-input{height:29px}.user-finder-container .user-finder-input{max-width:calc(100% - 30px - 30px - 20px)}.user-finder-container .search-button{margin-left:.5em;margin-right:.5em}", ""]);

// exports
